import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-key-operational',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './key-operational.component.html',
  styleUrl: './key-operational.component.css'
})
export class KeyOperationalComponent {

  baseApiUrl = environment.baseApiUrl;
  
}
